export default class problemaCorrectivo {
	constructor($scope,
				$routeParams,
				method,
                problemaCorrectivoService,
				$location,
				toastr,
                $uibModal,
                tipoEquipoService,
                proyectosService
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(problemaCorrectivoService);
			break;
			case 'new':
				this.create(problemaCorrectivoService,tipoEquipoService, proyectosService);
			break;
			case 'view':
				this.view($routeParams,
                    problemaCorrectivoService,
                    tipoEquipoService);
			break;
		}
	}

	list(problemaCorrectivoService){
        let self = this.scope;
        problemaCorrectivoService.getAll().then((resp, err) => {
			self.problemasCorrectivos = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.problemasCorrectivos.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, problemaCorrectivoService);
	}

	create(problemaCorrectivoService, tipoEquipoService, proyectosService){

        this.scope.inAction = false;
        this.scope.problemaCorrectivo = {proyecto: null};
        this.scope.showSelectProject = false;

        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.tipo_equipos = resp.data.message;
            });
        proyectosService.getAll()
            .then((resp) => {
                this.scope.proyectos = resp.data.message;
                if (this.scope.proyectos.length == 1) {
                    this.scope.problemaCorrectivo.proyecto = this.scope.proyectos[0]._id;
                } else {
                    this.scope.showSelectProject = true;
                }
            });
            
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                let data = {
                    nombre: this.scope.problemaCorrectivo.nombre,
                    descripcion: this.scope.problemaCorrectivo.descripcion,
                    tipoequipo: this.scope.problemaCorrectivo.tipoequipo._id,
                    severidad: this.scope.problemaCorrectivo.tipoequipo.severidad._id,
                    proyecto: this.scope.problemaCorrectivo.proyecto
                };
                problemaCorrectivoService.save(data).then((resp) => {
                    this.toastr.success('Problema creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/problema_correctivo');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al crear el problema!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

	view($routeParams,
        problemaCorrectivoService,
         tipoEquipoService){

		this.scope.aux = {};
        problemaCorrectivoService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.problemaCorrectivo = resp.data.message;
		}).catch((er) => {
			console.log(er);
        });
        
        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.tipo_equipos = resp.data.message;
            });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                problemaCorrectivoService.update(this.scope.problemaCorrectivo).then((resp) => {
                    this.toastr.success('Problema modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/problema_correctivo');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el problema!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,problemaCorrectivo, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Problema</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el "problema" de falla: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = problemaCorrectivo.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: problemaCorrectivo._id}).then((resp) => {
                    self.scope.problemasCorrectivos.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Problema eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error( 'Error al eliminar el Problema!','Error', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/problema_correctivo/problema_correctivo.js